__turbopack_context__.v({
  "season_navigator": "SeasonNavigator-module-scss-module__aSGO1G__season_navigator",
  "season_navigator__episodes": "SeasonNavigator-module-scss-module__aSGO1G__season_navigator__episodes",
  "season_navigator__loading": "SeasonNavigator-module-scss-module__aSGO1G__season_navigator__loading",
  "season_navigator_select": "SeasonNavigator-module-scss-module__aSGO1G__season_navigator_select",
});
